import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';

export const tableOperation = (data) => {
  return axios.post(`/api/v1/agent/operation`, data);
};

export const useTableOperation = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onError: (_, __, context) => {
      addNotification({
        type: 'error',
        title: 'Failed to load data',
      });
    },
    onSuccess: async (data) => {
      if (!data.success) {
        addNotification({
          type: 'error',
          title: data?.message || 'Failed to load data',
        });
      }
    },
    ...config,
    mutationFn: tableOperation,
  });
};
